import { EventType } from '$lib/services/analytics/events/common';
import createPersistentStore from '$lib/utils/persistent-store';

/**
 * A writable store that holds subscription information.
 * @typedef {object} SubscriptionDetails
 * @property {object} credentialsInfo - Information about user credentials.
 * @property {object} paymentInfo - Information about payment details.
 * @property {object} metaInfo - Additional metadata information.
 * @property {EventType} [metaInfo.logType] - the log to publish when this tx succeeds.
 * @property {{ code?: number; message: string; links?: Array<{ id: string; href: string }> } | null} error - Error information; `links` render as parent-gated links.
 */

/** @type {import('svelte/store').Writable<SubscriptionDetails>} */
export const subscription = createPersistentStore('subscription', {
	credentialsInfo: {},
	paymentInfo: {},
	metaInfo: { logType: EventType.Subscribe },
	error: null
});

/**
 * @param {SubscriptionDetails} subcriptionDetails new subscription details.
 */
export function saveSubscriptionStateToStore(subcriptionDetails) {
	subscription.update((/** @type {SubscriptionDetails} */ existingValue) => {
		return { ...existingValue, ...subcriptionDetails };
	});
}
